import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { cn } from '../utils/cn'

const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>>(
	({ className, value, ...props }, ref) => (
		<ProgressPrimitive.Root ref={ref} className={cn('relative h-1.5 w-full overflow-hidden rounded-full bg-primary/20', className)} {...props}>
			<ProgressPrimitive.Indicator
				className="h-full w-full flex-1 transition-all bg-gradient-to-b from-blue-500 to-blue-400"
				style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
			/>
		</ProgressPrimitive.Root>
	),
)
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
